import type { FirewallRule } from '@/entities/firewall';
import request from '@/shared/api/request';

export const deleteFirewallRule = (
  uuid: string,
  data: { [key: string]: FirewallRule[] },
): Promise<unknown> =>
  request({
    url: `/firewalls/${uuid}/rules/`,
    method: 'DELETE',
    data,
  });
